import React from 'react';
import { Text } from 'pcln-design-system';
export const SinglePinLabel = props => {
  const {
    name
  } = props;
  return React.createElement(Text, {
    bold: true,
    ml: 1,
    color: 'primary.base'
  }, name);
};